// "Tap to listen": the browser blocked the start (autoplay with sound needs a tap). The one button every player uses.
import { useTranslation } from "react-i18next";

export function TapToListenButton({ onTap, overlay, className }: { onTap(): void; overlay: boolean; className?: string }) {
  const { t } = useTranslation();
  if (overlay)
    return (
      <button
        type="button"
        data-testid="btn-tap-to-listen"
        onClick={onTap}
        className="absolute inset-0 z-[1] flex items-center justify-center border-none bg-black/60 text-white text-[13px] cursor-pointer"
      >
        ▶ {t("tap_to_listen", "Tap to listen")}
      </button>
    );
  return (
    <div className={className ?? "px-2 pt-2"}>
      <button
        type="button"
        data-testid="btn-tap-to-listen"
        onClick={onTap}
        className="w-full h-8 rounded-full bg-[var(--primary-muted)] text-[var(--primary)] dark:text-[var(--primary-on-surface)] text-xs font-medium"
      >
        ▶ {t("tap_to_listen", "Tap to listen")}
      </button>
    </div>
  );
}
